import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Styles from './styled';
import ArrowLink from '../Link';

const Component = ({ title = 'Useful links', links = [] }) => {
  return (
    <Styles className='useful_links'>
      {title && (
        <header>
          <h2 className='type-h5 color-bedtime'>{title}</h2>
        </header>
      )}
      {links.length > 0 && (
        <ul className='links'>
          {links.map(({ title: linkTitle, to, icon, ...linkProps }, i) => (
            <li key={i}>
              {icon}
              <ArrowLink to={to} {...linkProps}>
                {linkTitle}
              </ArrowLink>
            </li>
          ))}
        </ul>
      )}
    </Styles>
  );
};

Component.propTypes = {};

export default Component;
